import Icon from 'veui/components/Icon'
import { IconFolder } from 'dls-icons-vue'

Icon.register('folder', IconFolder)
